import { render, staticRenderFns } from "./exportConfig.vue?vue&type=template&id=27a6823e"
import script from "./exportConfig.vue?vue&type=script&lang=js"
export * from "./exportConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports